export default __webpack_public_path__ + "static/media/3306.54edd073.png";